import React, { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { handleGetLanguage } from "../utils/languageStorage";

export default function ResetPassword() {
    const { token } = useParams();
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");

    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const navigate = useNavigate();
    const language = handleGetLanguage();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !token || !password || !passwordConfirmation) {
            toast.error(language === "ka" ? "გთხოვთ შეავსეთ ყველა ველი" : "Fill all fields");
            return;
        }

        try {
            const res = await fetch("https://api.onlybrands.ge/api/password/reset", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email,
                    token,
                    password,
                    password_confirmation: passwordConfirmation,
                }),
            });

            const data = await res.json();

            if (res.ok) {
                toast.success(language === "ka" ? "პაროლი წარმატებით შეიცვალა ✔" : "Password reset successful ✔");
                navigate("/"); // or login page
            } else {
                toast.error(data.email || (language === "ka" ? "პაროლის შეცვლა ვერ მოხერხდა" : "Failed to reset password"));
            }
        } catch (err) {
            toast.error(language === "ka" ? "სერვერის შეცდომა" : "Server error");
        }
    };

    return (
        <section className="flex items-center justify-center min-h-screen bg-orange-50 dark:bg-slate-900 px-4">
            <div className="bg-white dark:bg-slate-800 p-8 rounded-md shadow-lg w-full max-w-md">
                <h2 className="text-2xl font-bold text-center text-orange-600 dark:text-white mb-4">
                    {language === "ka" ? "პაროლის აღდგენა" : "Reset Password"}
                </h2>
                <p className="text-sm text-center text-slate-500 dark:text-slate-400 mb-6">
                    {language === "ka" ? `შეიყვანეთ ახალი პაროლი ელ.ფოსტისთვის: ${email}` : `Set a new password for ${email}`}
                </p>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block mb-1 text-sm font-medium text-slate-700 dark:text-slate-200">
                            {language === "ka" ? "ახალი პაროლი" : "New Password"}
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-2 rounded-md border border-gray-300 dark:border-gray-700 dark:bg-slate-800 dark:text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-1 text-sm font-medium text-slate-700 dark:text-slate-200">
                            {language === "ka" ? "დაადასტურე პაროლი" : "Confirm Password"}
                        </label>
                        <input
                            type="password"
                            value={passwordConfirmation}
                            onChange={(e) => setPasswordConfirmation(e.target.value)}
                            className="w-full px-4 py-2 rounded-md border border-gray-300 dark:border-gray-700 dark:bg-slate-800 dark:text-white"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full py-2 bg-orange-600 text-white font-semibold rounded-md hover:bg-orange-700"
                    >
                        {language === "ka" ? "შეცვალე პაროლი" : "Reset Password"}
                    </button>
                </form>
            </div>
        </section>
    );
}
